<template>
  <!-- 能耗统计 -->
  <div class="app-container">
    <div class="title-container">
      <span class="runDays">能源看板</span>
      {{ energyData.iotPlatformName }}
      <span class="time">{{ timeStr }}</span>
    </div>
    <div class="content-container clearfix">
      <div class="top-container clearfix">
        <div class="left-container">
          <div class="title">能耗统计</div>
          <div class="state-container clearfix">
            <div
              class="state-item clearfix"
              :class="{ last: (index + 1) % 4 == 0, 'last-row': index > 7 }"
              v-for="(item, index) in monitorData"
              :key="index"
            >
              <img :src="`/static/image/equip/` + item.icon" alt="" />
              <div class="equip-info">
                <div class="equip-name">{{ item.label }}</div>
                <div class="equip-state clearfix">
                  <span class="count">{{ item.value }}</span> {{ item.unit }}
                  <span class="fr percent" v-if="(index + 1) % 4 == 0">
                    <img
                      v-if="item.increase"
                      src="/static/image/equip/increase.png"
                      alt=""
                    />
                    <img v-else src="/static/image/equip/reduce.png" alt="" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="middle-container">
          <div class="title">用能占比</div>
          <div class="echart-container" id="echart-panel-pie"></div>
        </div>
        <div class="right-container">
          <div class="title">运行情况</div>
          <div class="content">
            <div class="content-item clearfix">
              <div class="content-title">
                <img src="/static/image/equip/yunxingtianshu-icon.png" alt="" />
                运行天数
              </div>
              <div class="content-value">
                <span :title="energyData.runDays">{{
                  energyData.runDays || 0
                }}</span>
                天
              </div>
            </div>
            <div class="content-item clearfix">
              <div class="content-title">
                <img src="/static/image/equip/zongnenghao-icon.png" alt="" />
                累计总能耗
              </div>
              <div class="content-value">
                <span :title="totalEnergy">{{
                  totalEnergy.toFixed(2) || 0
                }}</span
                >kgce
              </div>
            </div>
            <div class="content-item clearfix">
              <div class="content-title">
                <img
                  src="/static/image/equip/yongnengyichang-icon.png"
                  alt=""
                />
                用能异常次数
              </div>
              <div class="content-value">
                <span :title="energyData.ynyccs">{{
                  energyData.ynyccs || 0
                }}</span>
                次
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container clearfix">
        <div class="left-container">
          <div class="title">能耗趋势</div>
          <div class="echart-container" id="echart-panel-line"></div>
        </div>
        <div class="right-container">
          <div class="title">用能排名</div>
          <div class="echart-container" id="echart-panel"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookie from "js-cookie";

import * as echarts from "echarts";
import * as utils from "@/utils";
import {
  energyMonitoring,
  energyEfficiency,
  energyRanking,
  energyTrend
} from "@/api/basicManSystem/energyMonitor.js";

import { integratedOperationMonitoring } from "@/api/basicManSystem/comprehenOperateMonitor.js";

export default {
  components: {},
  data() {
    return {
      timeStr: utils.getTotime() + `(星期${utils.getWeek()})`,

      energyData: {},

      monitorData: [], // 能耗统计

      efficiencyData: [], // 用能占比

      rankData: [], // 排名

      trendData: [], // 趋势

      echartPanel: null, // echart面板

      echartPanelLine: null, // 折线面板

      echartPanelPie: null, // 饼状图

      timer: null,

      totalEnergy: 0
    };
  },

  created() {
    this.getEnergy();
    this.getMonitor();
    this.getEfficiency();
    this.getTrend();
    this.getRank();
    this.$nextTick(() => {
      this.changeTime();
    });
  },

  mounted() {
    window.addEventListener("resize", () => {
      setTimeout(() => {
        if (!utils.isNull(this.echartPanel)) {
          this.echartPanel.resize();
        }
        if (!utils.isNull(this.echartPanelLine)) {
          this.echartPanelLine.resize();
        }
        if (!utils.isNull(this.echartPanelPie)) {
          this.echartPanelPie.resize();
        }
      }, 400);
    });
  },

  beforeDestroy() {
    if (!utils.isNull(this.timer)) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  methods: {
    // 创建图表
    createChart() {
      if (this.rankData.length == 0) {
        if (!utils.isNull(this.echartPanel)) {
          this.echartPanel.clear();
        }
        return;
      }
      let legendData = [];
      let xAxisData = [];
      let seriesData = [];
      for (let i of this.rankData) {
        legendData.push(i.area);
        xAxisData.push(i.area);
        seriesData.push(i.energy);
      }

      // 基于准备好的dom，初始化echarts实例
      this.echartPanel = echarts.init(document.getElementById("echart-panel"));
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        grid: {
          left: "2%",
          right: "2%",
          top: "10%",
          bottom: "2%",
          containLabel: true
        },
        legend: {
          data: legendData
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            show: true,
            lineStyle: {
              // 设置分割线单独的样式
              color: "#5492ED"
            }
          }
        },
        yAxis: {
          name: "kgce",
          nameTextStyle: {
            // 坐标轴名字文本样式设置
            color: "#5492ED",
            fontSize: 12
          },
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: "#5492ED"
            }
          },
          splitLine: {
            // 轴上的分割线
            show: true,
            lineStyle: {
              // 设置分割线单独的样式
              color: "#5492ED"
            }
          }
        },
        series: [
          {
            type: "bar",
            // barWidth: '30',
            data: seriesData,
            itemStyle: {
              // 不同颜色
              normal: {
                color: function(params) {
                  var colorList0 = [
                    // '#42d2b9',
                    // '#4cb5f2',
                    // '#ddb146',
                    // '#19AA8D',
                    // '#cdbed1',

                    "#249CF9",
                    "#EB6F49",
                    "#FDB628",
                    "#00E4EC",
                    "#69FD28",
                    "#C490BF",
                    "#FFF100",
                    "#486A00",
                    "#F6B37F",
                    "#7ECEF4",
                    "#22AC38",
                    "#7E6B5A"
                  ];
                  let colorList = [];
                  if (seriesData.length > colorList0.length) {
                    for (let i = 0; i < seriesData.length; i++) {
                      let index = i % colorList0.length;

                      colorList.push(colorList0[index]);
                    }
                  } else {
                    colorList = colorList0;
                  }
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      };

      this.echartPanel.setOption(option);
    },

    // 创建折线图
    createChartLine() {
      if (this.trendData.length == 0) {
        if (!utils.isNull(this.echartPanelLine)) {
          this.echartPanelLine.clear();
        }
        return;
      }
      let colorList = ["#5999F4", "#FB7527", "#3BD9C1", "#BB44A8"];
      let legendData = [];
      let xAxisData = [];
      let seriesData = [];
      for (let i =0;i<this.trendData.length;i++) {
        let color = colorList[i % colorList.length];
        legendData.push({
          name: this.trendData[i].type,
          textStyle: {
            color
          }
        });
        if (i == 0) {
          let first = this.trendData[0];
          for (let j = 0; j < first.list.length; j++) {
            xAxisData.push(j + 1 + "月");
          }
        }
        for (let j =0;j<this.trendData[i].list.length;j++) {
          this.trendData[i].list[j] =
            this.trendData[i].list[j] == 0
              ? 0
              : this.trendData[i].list[j].toFixed(2);
        }
        seriesData.push({
          name: this.trendData[i].type,
          type: "line",
          smooth: true,
          stack: "",
          areaStyle: {
            opacity: 0.5
          },
          itemStyle: {
            normal: {
              lineStyle: {
                color
              }
            }
          },
          data: this.trendData[i].list
        });
      }
      // 基于准备好的dom，初始化echarts实例
      this.echartPanelLine = echarts.init(
        document.getElementById("echart-panel-line")
      );
      // 指定图表的配置项和数据
      let option = {
        color: colorList,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          data: legendData,
          orient: "horizontal",
          top: "2%"
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        grid: {
          left: "2%",
          right: "2%",
          top: "10%",
          bottom: "2%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xAxisData,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#5492ED",
                fontSize: "12"
              }
            },
            axisLine: {
              // 轴线
              show: true,
              lineStyle: {
                // 设置分割线单独的样式
                color: "#5492ED"
              }
            }
          }
        ],
        yAxis: [
          {
            name: "kgce",
            nameTextStyle: {
              // 坐标轴名字文本样式设置
              color: "#5492ED",
              fontSize: 12
            },
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#5492ED",
                fontSize: "12"
              }
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: "#5492ED"
              }
            },
            splitLine: {
              // 轴上的分割线
              show: true,
              lineStyle: {
                // 设置分割线单独的样式
                color: "#5492ED"
              }
            }
          }
        ],
        series: seriesData
      };

      this.echartPanelLine.setOption(option);
    },

    // 创建饼状图
    createChartPie() {
      if (this.efficiencyData.length == 0) {
        if (!utils.isNull(this.echartPanelPie)) {
          this.echartPanelPie.clear();
        }
        return;
      }
      let legendData = [];
      let seriesData = [];
      for (let i of this.efficiencyData) {
        legendData.push(i.area);
        seriesData.push({
          name: i.area,
          value: i.count
        });
      }
      // 基于准备好的dom，初始化echarts实例
      this.echartPanelPie = echarts.init(
        document.getElementById("echart-panel-pie")
      );
      // 指定图表的配置项和数据
      let option = {
        color: ["#B742A5", "#E47931", "#5492ED"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "horizontal",
          bottom: "2%",
          data: legendData,
          textStyle: {
            color: "#249CF9"
          }
        },
        series: [
          {
            name: "用能占比",
            type: "pie",
            center: ["50%", "50%"],
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter: "{d}%"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "14"
              }
            },
            data: seriesData
          }
        ]
      };

      this.echartPanelPie.setOption(option);
    },

    // 设置定时 改变时间
    changeTime() {
      if (utils.isNull(this.timer)) {
        this.timer = setInterval(() => {
          this.timeStr = utils.getTotime() + `(星期${utils.getWeek()})`;
        }, 1000);
      }
    },

    // 获取标题
    getEnergy() {
      integratedOperationMonitoring().then(res => {
        if (res.data.code == 200) {
          this.energyData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取能耗统计数据
    getMonitor() {
      energyMonitoring().then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.monitorData.push({
            icon: "nian-icon.png",
            label: "当年累计总能耗",
            value: data.total.thisYear.toFixed(2),
            unit: "kgce"
          });
          this.monitorData.push({
            icon: "yue-icon.png",
            label: "当月总能耗",
            value: data.total.thisMonth.toFixed(2),
            unit: "kgce"
          });
          this.monitorData.push({
            icon: "ri-icon.png",
            label: "当日总能耗",
            value: data.total.totay.toFixed(2),
            unit: "kgce"
          });
          this.monitorData.push({
            icon: "huanbi-icon.png",
            label: "总能耗月环比",
            value: data.hb.hb,
            unit: "",
            percent: "",
            increase: !data.hb.hb.includes("-")
          });
          // 电
          this.monitorData.push({
            icon: "dian-icon.png",
            label: "当年累计用电",
            value: data.electricity.thisYear.toFixed(2),
            unit: "kwh"
          });
          this.monitorData.push({
            icon: "dian-icon.png",
            label: "当月用电",
            value: data.electricity.thisMonth.toFixed(2),
            unit: "kwh"
          });
          this.monitorData.push({
            icon: "dian-icon.png",
            label: "当日用电",
            value: data.electricity.totay.toFixed(2),
            unit: "kwh"
          });
          this.monitorData.push({
            icon: "dian-icon.png",
            label: "用电月环比",
            value: data.hb.hbd,
            unit: "",
            percent: "",
            increase: !data.hb.hbd.includes("-")
          });
          // 水
          this.monitorData.push({
            icon: "shui-icon.png",
            label: "当年累计用水",
            value: data.wate.thisYear.toFixed(2),
            unit: "t"
          });
          this.monitorData.push({
            icon: "shui-icon.png",
            label: "当月用水",
            value: data.wate.thisMonth.toFixed(2),
            unit: "t"
          });
          this.monitorData.push({
            icon: "shui-icon.png",
            label: "当日用水",
            value: data.wate.totay.toFixed(2),
            unit: "t"
          });
          this.monitorData.push({
            icon: "shui-icon.png",
            label: "用水月环比",
            value: data.hb.hbw,
            unit: "",
            percent: "",
            increase: !data.hb.hbw.includes("-")
          });
          this.totalEnergy = data.total.lj;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取用能占比
    getEfficiency() {
      energyEfficiency().then(res => {
        if (res.data.code == 200) {
          this.efficiencyData = res.data.data;
          this.$nextTick(() => {
            this.createChartPie();
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取趋势分析
    getTrend() {
      energyTrend().then(res => {
        if (res.data.code == 200) {
          this.trendData = res.data.data;
          this.$nextTick(() => {
            this.createChartLine();
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取异常趋势分析
    getRank() {
      energyRanking().then(res => {
        if (res.data.code == 200) {
          this.rankData = res.data.data;
          this.$nextTick(() => {
            this.createChart();
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background: url("/static/image/equip/bg.png") no-repeat center;
  background-size: cover;
  padding: 0 20px;
  .title-container {
    position: relative;
    height: 96px;
    line-height: 88px;
    text-align: center;
    color: #ffffff;
    font-size: 36px;
    font-weight: bold;
    background: url("/static/image/equip/top-bj@2x.png") no-repeat center;
    background-size: 100% 100%;
    .runDays {
      position: absolute;
      left: 0;
      width: 492px;
      margin-bottom: 0;
      font-size: 20px;
      padding-top: 6px;
      text-align: center;
    }
    .time {
      position: absolute;
      width: 30%;
      right: 0;
      font-size: 20px;
      padding-top: 6px;
    }
  }
  .content-container {
    height: calc(100% - 96px);
    .top-container {
      height: 280px;
      margin-bottom: 10px;
      .left-container {
        float: left;
        width: calc(100% - 760px);
        margin-right: 10px;
        height: 100%;
        .state-container {
          width: 100%;
          height: calc(100% - 30px);
          overflow-y: auto;
          .state-item {
            float: left;
            width: calc(25% - 8px);
            height: 80px;
            margin-right: 5px;
            margin-bottom: 5px;
            padding: 15px 0 0 20px;
            background: rgba(0, 186, 255, 0.1);
            border: 1px solid #369aff;
            img {
              float: left;
              width: 30px;
              height: 30px;
              margin-top: 10px;
            }
            .equip-info {
              float: right;
              width: calc(100% - 40px);
              color: #ffffff;
              font-size: 14px;
              .equip-state {
                margin-top: 10px;
                font-size: 12px;
                span.count {
                  color: #01d4f9;
                  font-size: 18px;
                }
                span.percent {
                  height: 12px;
                  line-height: 10px;
                  margin-top: 8px;
                  padding-right: 6px;
                  img {
                    width: 8px;
                    height: 10px;
                    margin-top: 0;
                    margin-right: 2px;
                  }
                }
              }
            }
          }
          .state-item.last {
            width: calc(25% + 9px);
            margin-right: 0;
          }
          .state-item.last-row {
            margin-bottom: 0;
          }
        }
      }
      .middle-container {
        float: left;
        width: 370px;
        height: 100%;
        margin-right: 10px;
      }
      .right-container {
        float: left;
        width: 370px;
        height: 100%;
        .content {
          height: calc(100% - 30px);
          background: rgba(0, 186, 255, 0.1);
          border: 1px solid #369aff;
          padding: 20px;
          .content-item {
            .content-title {
              font-size: 24px;
              color: #01d4f9;
              height: 40px;
              line-height: 40px;
              img {
                width: 24px;
                height: 24px;
                vertical-align: middle;
                margin-right: 16px;
              }
            }
            .content-value {
              color: #ffffff;
              text-align: right;
              span {
                display: inline-block;
                font-size: 24px;
                margin-right: 6px;
                width: calc(100% - 48px);
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
          .content-item:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .bottom-container {
      height: calc(100% - 300px);
      .left-container {
        float: left;
        width: calc(100% - 760px);
        margin-right: 10px;
        height: 100%;
      }
      .right-container {
        float: left;
        width: 750px;
        height: 100%;
      }
    }
  }

  .echart-container {
    height: calc(100% - 30px);
    background: rgba(0, 186, 255, 0.1);
    border: 1px solid #369aff;
  }

  .title {
    position: relative;
    color: #ffffff;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
  }
}
</style>
